import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import {
  MODULES_KEY,
  PERMISSION_OBJECT,
  ROUTES_MODULES_KEY,
} from '../../common/constants';
import HourLogsHistory from './HourLogsHistory';
import './hourLogsHistory.less';

const HourLogsHistoryWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.HOURS_LOG_HISTORY}`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.HOURS_LOG_HISTORY}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <HourLogsHistory {...props} />
        </AccessControl>
      )}
    />
  </Switch>
);

export default HourLogsHistoryWrapper;
